var render = function render() {
  var _vm$allFileTemplate;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: _vm.$t("信息确认"),
      visible: _vm.emailVisiable,
      width: 800,
      footer: null
    },
    on: {
      "update:visible": function ($event) {
        _vm.emailVisiable = $event;
      },
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.closeEmailVisible
    }
  }, [_c("div", [_c("a-form-model", {
    ref: "emailForm",
    attrs: {
      model: _vm.emailForm,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("收件人邮箱"),
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("recipient");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")])], 1), _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.recipient, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: true,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("recipient", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1), _c("a-row", {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px"
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.notifyObj.is_cc
    },
    on: {
      change: e => _vm.onCheckChange(e, "is_cc")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加抄送人")) + " ")]), _c("a-checkbox", {
    attrs: {
      checked: _vm.notifyObj.is_bcc
    },
    on: {
      change: e => _vm.onCheckChange(e, "is_bcc")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加密送人")) + " ")])], 1), _vm.notifyObj.is_cc ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("抄送人邮箱"),
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("cc");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")])], 1) : _vm._e(), _vm.notifyObj.is_cc ? _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.cc, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: true,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("cc", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _vm.notifyObj.is_bcc ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("密送人邮箱"),
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_vm.notifyObj.is_bcc ? _c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("bcc");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.notifyObj.is_bcc ? _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.bcc, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: true,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("bcc", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _c("h3", {
    staticClass: "email-title"
  }, [_vm._v(_vm._s(_vm.$t("邮件内容")))]), _c("a-form-model-item", {
    attrs: {
      prop: "title",
      label: _vm.$t("邮件主题")
    }
  }, [_c("a-input", {
    attrs: {
      "max-length": 100,
      placeholder: _vm.$t("请输入") + _vm.$t("邮件主题")
    },
    model: {
      value: _vm.notifyObj.title,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "title", $$v);
      },
      expression: "notifyObj.title"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("邮件正文")
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.notifyObj.content,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "content", $$v);
      },
      expression: "notifyObj.content"
    }
  })], 1), ((_vm$allFileTemplate = _vm.allFileTemplate) === null || _vm$allFileTemplate === void 0 ? void 0 : _vm$allFileTemplate.length) > 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("关联模板")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.notifyObj.fileTemplate,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "fileTemplate", $$v);
      },
      expression: "notifyObj.fileTemplate"
    }
  }, _vm._l(_vm.allFileTemplate, function (item) {
    return _c("a-select-option", {
      key: item.url,
      attrs: {
        value: item.url
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("div", [_vm._v(_vm._s("i:" + _vm.$t("点击发送后将流转至审核流下一节点并发送邮件，请谨慎操作") + "！"))])], 1) : _vm._e()], 1), _c("div", {
    staticClass: "send-btn"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.closeEmailVisible
    }
  }, [_vm._v(_vm._s(_vm.$t("发送")))])], 1)], 1)]), _vm.addEmailVisible ? _c("emailModel", {
    attrs: {
      addEmailTitle: _vm.addEmailTitle,
      addEmailVisible: _vm.addEmailVisible
    },
    on: {
      getEmails: _vm.settingEmail,
      cancelAddEmail: _vm.cancelAddEmail
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };